import { OPENPANEL_CLIENT_ID, OPENPANEL_API_URL, ENVIRONMENT } from 'constants';
import { OpenPanel } from '@openpanel/web';

let op = null;

const skipOpenPanel = () => {
  return !OPENPANEL_CLIENT_ID || new URLSearchParams(window.location.search).get('skip_op') === 'true';
};

export const initOpenPanel = () => {
  if (skipOpenPanel()) {
    console.debug('skipping initOpenPanel');
    return;
  }

  op = new OpenPanel({
    clientId: OPENPANEL_CLIENT_ID,
    apiUrl: OPENPANEL_API_URL,
    trackScreenViews: false,
    trackOutgoingLinks: true,
    trackAttributes: true,
  });

  op.setGlobalProperties({ environment: ENVIRONMENT });
};

export const identifyOpenPanel = (user) => {
  if (skipOpenPanel() || !op) {
    console.debug('skipping identifyOpenPanel');
    return;
  }

  op.identify({
    profileId: user.id,
    firstName: user.first_name,
    lastName: user.last_name,
    email: user.email,
    properties: {
      displayName: user.display_name,
      accountId: user.account.id,
      accountName: user.account.name,
    },
  });
};

export const trackPageOpenPanel = (path) => {
  console.log('trackPageOpenPanel', path);
  if (skipOpenPanel() || !op) {
    console.debug('skipping trackPageOpenPanel');
    return;
  }

  op.screenView(path);
};

export const trackOpenPanel = (event, properties = {}) => {
  if (skipOpenPanel() || !op) {
    console.debug('skipping trackOpenPanel', event);
    return;
  }

  op.track(event, properties);
};
